import React, { Component } from 'react';
import Item from '../item';
import { NoContent } from '../../ui';

export default class extends Component {
    render() {
        const { data, userData, onItemClick, onItemClose, onItemDoubleClick } = this.props;

        return (
            <div className="session-list">
            {
                data.map((item, index)=>{
                    return (<Item data={item} 
                                  userData={userData}
                                  onClick={onItemClick}
                                  onClose={onItemClose}
                                  onDoubleClick={onItemDoubleClick} />
                            )
                })
            }
            { data.length ? null: <NoContent text="暂无会话"/> }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/session/list/base.js